import {
	getExpires
} from './auth.js'
// import { barText } from '../lang/bar'
import store from '../../store.js'
import {
	setParamsJson,
	setParamsIp,
	setParamsUdid
} from './params.js'
import {
	areaCode
} from './areaCode.js'
const os = require('os');

export function browserType() {
	var u = navigator.userAgent,
		app = navigator.appVersion;
	return { //移动终端浏览器版本信息
		trident: u.indexOf('Trident') > -1, //IE内核
		presto: u.indexOf('Presto') > -1, //opera内核
		webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
		gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
		mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
		ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
		android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
		iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
		iPad: u.indexOf('iPad') > -1, //是否iPad
		webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
	}
}

export function isMobile() {
	var u = navigator.userAgent,
		app = navigator.appVersion;
	if (navigator.userAgent.match(/Android/i) ||
		navigator.userAgent.match(/webOS/i) ||
		navigator.userAgent.match(/iPhone/i) ||
		navigator.userAgent.match(/iPad/i) ||
		navigator.userAgent.match(/iPod/i) ||
		navigator.userAgent.match(/BlackBerry/i) ||
		navigator.userAgent.match(/Windows Phone/i)
	) return true;
	return false;
}

// //设置底部菜单菜称
// export function setBarItem(){
// 	//设置tab
// 	uni.setTabBarItem({
// 			index: 0,
// 			text: barText.discover
// 	});
// 	uni.setTabBarItem({
// 			index: 1,
// 			text: barText.library
// 	});
// 	uni.setTabBarItem({
// 			index: 2,
// 			text: barText.bookshelf
// 	});
// 	uni.setTabBarItem({
// 			index: 3,
// 			text: barText.profile
// 	});
// }

export function checkExpiresTime() {
	let time = getExpires()
	if (time != '') {
		let nowT = new Date().getTime()
		let expT = new Date(time).getTime()
		//提前30分钟过期
		if (expT < nowT + 1800000) {
			store.commit('logout')
		}
	} else(
		store.commit('logout')
	)
}


export function getAppInfo() {

	// geoplugin_request,
	// geoplugin_city,
	// geoplugin_region,
	// geoplugin_regionCode,
	// geoplugin_regionName,
	// geoplugin_countryCode,
	// geoplugin_countryName

	let ref = document.referrer
	try {
		const user_ip = geoplugin_request()
		const country = geoplugin_countryName()
		const city = geoplugin_city()
		const system = browserRedirect()
		getDeviceId()

		// const res = uni.getSystemInfoSync();
		store.commit('setUniqueness', 'res.deviceId')
		let option = {
			udid: '',
			systemversion: system,
			systemname: '',
			ip: user_ip,
			country: country,
			city: city
		}
		// console.log(option);
		setParamsJson(option)
	} catch (e) {
		console.log('appinfo....e', e)
		// error
	}
}


export function getAreaCode(info) {
	setParamsIp(info.ip)
	let nation = info.ad_info.nation
	let areas = areaCode
	let index = areas.findIndex((val) => {
		return val.zh == nation
	})
	if (index) {
		store.commit('setfristLocationCode', areas[index].code)
		store.commit('setLocationCode', areas[index].code)
	}
}

//获取操作系统类型
export function browserRedirect() {
	var sUserAgent = navigator.userAgent;
	var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
	var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform ==
		"Macintosh") || (navigator.platform == "MacIntel");
	if (isMac) return "Mac";
	var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
	if (isUnix) return "Unix";
	var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
	if (isLinux) return "Linux";
	if (isWin) {
		var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
		if (isWin2K) return "Win2000";
		var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
		if (isWinXP) return "WinXP";
		var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
		if (isWin2003) return "Win2003";
		var isWinVista = sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
		if (isWinVista) return "WinVista";
		var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
		if (isWin7) return "Win7";
		var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
		if (isWin10) return "Win10";
	}
	return "other";
}

export function getDeviceId() {
	let excludes = {};
	let options = {
		excludes: excludes
	}
	console.log(options)
	Fingerprint2.get(options, function(components) {
		// 参数
		const values = components.map(function(component) {
			return component.value
		});
		// 指纹
		const murmur = Fingerprint2.x64hash128(values.join(''), 31);
		setParamsUdid(murmur)
		// view.innerHTML += '<p class="pp">标识 : ' + murmur + '</p>';
		// console.log("murmurmurmur",murmur);
		// sessionStorage.setItem("Finger", murmur); //存入标识值
		// console.log(murmur);
	});
}

export function mobileInfo(){ 
    //判断数组中是否包含某字符串  
    Array.prototype.contains = function(needle) {  
        for (i in this) {  
            if (this[i].indexOf(needle) > 0)  
                return i;  
        }  
        return -1;  
    }  
    var deviceType = navigator.userAgent;//获取userAgent信息  
    document.write(deviceType);//打印到页面  
    var md = new MobileDetect(deviceType);//初始化mobile-detect  
    var os = md.os();//获取系统  
    var version = "";//系统的版本号   
    var model = "";  //设备型号
    if (os == "iOS") {//ios系统的处理  
        version =  md.version("iPhone");
        os = md.os();  
        model = md.mobile();  
    } else if (os == "AndroidOS") {//Android系统的处理  
        os = md.os();  
        version = md.version("Android");
        var sss = deviceType.split(";");  
        var i = sss.contains("Build/");  
        if (i > -1) {  
            model = sss[i].substring(0, sss[i].indexOf("Build/"));  
        }  
    }  
    //组装信息
    var info = {
      os:os,//系统类型
      version:version,//系统版本号
      model:model //设备型号
    };
    return info;
} 
